// MotionTyping.jsx
import { motion, useAnimation } from "framer-motion";
import { useEffect, useRef } from "react";

export default function MotionTyping({
  text = "We are IOI Studio",
  stagger = 0.04,
  initialDelay = 0,
  repeatDelay = 0.1,
}) {
  const controls = useAnimation();
  const characters = Array.from(text);
  const cancelledRef = useRef(false);

  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: stagger,
        delayChildren: initialDelay,
      },
    },
  };

  const charVariant = {
    hidden: { opacity: 0, y: 8 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.25, ease: "easeOut" },
    },
  };

  useEffect(() => {
    cancelledRef.current = false;

    const run = async () => {
      // wait for mount
      await Promise.resolve();

      while (!cancelledRef.current) {
        await controls.start("visible");
        if (cancelledRef.current) break;

        await new Promise((r) => setTimeout(r, repeatDelay * 1000));
        if (cancelledRef.current) break;

        await controls.start("hidden");
      }
    };

    run();

    return () => {
      cancelledRef.current = true;
      controls.stop(); // ⛔ stop all pending animations
    };
  }, [controls, repeatDelay]);

  return (
    <motion.h1
      className="text-sm font-medium text-transparent bg-clip-text bg-gradient-to-br from-gray-500 to-gray-500 whitespace-nowrap flex"
      variants={container}
      initial="hidden"
      animate={controls}
    >
      {characters.map((char, i) => (
        <motion.span key={i} variants={charVariant} className={char === " " ? "mr-1 inline-block" : "inline-block"}>
          {char}
        </motion.span>
      ))}
    </motion.h1>
  );
}
